$(function ($) {
  setTimeout(function(){ 
    equalheight('.product-card__title');
    equalheight('.product-card__image-with-placeholder-wrapper');
  }, 3000); 

  $(window).resize(function() {
    equalheight('.product-card__title');
    equalheight('.product-card__image-with-placeholder-wrapper');
  }); 

  $('.sidebar-content > .title').on("click", function (e) {
    $(this).next('.inner-content').slideToggle(600);
    $(this).toggleClass('open');
    e.stopPropagation();
    e.preventDefault();
  });
  $('.clickdown').on("click", function (e) {
    $(this).parent().next('ul').slideToggle(600);
    $(this).toggleClass('open');
    e.stopPropagation();
    e.preventDefault();
  });
  $('.dataclick').on("click", function (e) {
    $(this).next('ul').slideToggle(600);
    $(this).toggleClass('open');
    e.stopPropagation();
    e.preventDefault();
  });
  $('.site-nav__link--button').on("click", function (e) {
    $(this).next('.site-nav__dropdown').slideToggle(600);
    $(this).toggleClass('open');
    e.stopPropagation();
    e.preventDefault();
  });

  $('.prod-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    fade: false,
    asNavFor: '.shop-slider-nav'
  });
  $('.shop-slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.prod-slider',
    dots: false,
    arrows: true,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical: false
        }
      }
    ]
  });
  $('.btn.plus').click(function(e) {
    e.preventDefault();
    fieldName = $(this).attr('field');
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    if (!isNaN(currentVal)) {
      $('input[name=' + fieldName + ']').val(currentVal + 1);
    } else {
      $('input[name=' + fieldName + ']').val(1);
    }
  });
  $(".btn.minus").click(function(e) {
    e.preventDefault();
    fieldName = $(this).attr('field');
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    if (!isNaN(currentVal) && currentVal > 1) {
      $('input[name=' + fieldName + ']').val(currentVal - 1);
    } else {
      $('input[name=' + fieldName + ']').val(1);
    }
  });
  $('#parentHorizontalTab').easyResponsiveTabs({
    type: 'horizontal', //Types: default, vertical, accordion
    width: 'auto', //auto or any width like 600px
    fit: true, // 100% fit in a container
    closed: 'accordion', // Start closed if in accordion view
    tabidentify: 'hor_1', // The tab groups identifier
    activate: function(event) { // Callback function if tab is switched
      var $tab = $(this);
      var $info = $('#nested-tabInfo2');
      var $name = $('span', $info);
      $name.text($tab.text());
      $info.show();
    }
  });
  
  setTimeout(function(){ 
    $('.recommand-slider').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      dots: false,
      arrows: true,        
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            vertical: false
          }
        },
        {
          breakpoint: 380,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical: false
          }
        }

      ]
    });
  }, 1000); 
});